import { render, staticRenderFns } from "./Kol.vue?vue&type=template&id=5b79f45e&scoped=true&"
import script from "./Kol.vue?vue&type=script&lang=js&"
export * from "./Kol.vue?vue&type=script&lang=js&"
import style0 from "./Kol.vue?vue&type=style&index=0&id=5b79f45e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79f45e",
  null
  
)

export default component.exports